import { render, staticRenderFns } from "./MemberMessages.vue?vue&type=template&id=42a5539d&scoped=true&"
import script from "./MemberMessages.vue?vue&type=script&lang=js&"
export * from "./MemberMessages.vue?vue&type=script&lang=js&"
import style0 from "./MemberMessages.vue?vue&type=style&index=0&id=42a5539d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a5539d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VSheet,VSkeletonLoader})
